module.exports = __webpack_public_path__ + "img/2025-02-13d_2.4aa86460.jpg";